import $ from 'jquery';

// Gallery Images
const colorboxDefaults = {
	transition: 'fade',
	fixed: true,
	opacity: .85,
	scalePhotos: false,
	width: "100%",
	height: "100%",
	innerWidth: 600,
	maxWidth: '95%',
	maxHeight: '95%',
	scrolling: false,
	next: '',
	previous: '',
	rel: 'colorbox',
	close: '<span>Close</span>',
	onOpen: function() {
		$('body').addClass('colorbox--open');
	},
	onClosed: function() {
		$('body').removeClass('colorbox--open');
	}
};

export default class Colorbox {
	constructor() {
		const selector_component = '.pageHeading__mediaItems';
		const selector_targets = '.colorbox';
		$(selector_targets).colorbox(colorboxDefaults);
	}
}

// If the 'View Gallery' buttons is clicked.
const galleryLinks = '.colorbox';
const firstLink = $(galleryLinks).first();
const firstLinkHref = '/wp-content/uploads/2023/11/harmon-gallery-logo.png';
const remainingLinks = $(galleryLinks).not(firstLink).attr('href');

$('#show-gallery').on("click", function() {
	$.colorbox({
		href: firstLinkHref,
		rel: 'colorbox',
		transition: 'fade',
		fixed: true,
		opacity: .85,
		scalePhotos: false,
		maxWidth: '95%',
		maxHeight: '95%',
		initialWidth: '100%',
		initialHeight: '100%',
		scrolling: false,
		next: '',
		previous: '',
		close: '<span>Close</span>',
		onOpen: function() {
			$('body').addClass('colorbox--open');
		},
		onClosed: function() {
			$('body').removeClass('colorbox--open');
		}
	  });
});


// Contact Form
const form = document.querySelector('.gform_wrapper');

$('#contact-form button').on("click", function() {
	$.colorbox({
		html: form,
		rel: 'colorbox',
		transition: 'fade',
		fixed: true,
		opacity: .85,
		scalePhotos: false,
		maxWidth: '100%',
		maxHeight: '95%',
		initialWidth: '100%',
		initialHeight: '100%',
		scrolling: false,
		next: '',
		previous: '',
		close: '<span>Close</span>',
		onOpen: function() {
			$('body').addClass('colorbox--open');
		},
		onClosed: function() {
			$('body').removeClass('colorbox--open');
		}
	});

	const buttonId = this.id;

	// Gets reference to the email field in the contact form
	const inputField:any = form.querySelector('input[name="input_18"]');

	// Updates email value
	inputField.value = buttonId;
});